import { css } from 'styled-components';

export const FlexRowCenter = css`
        display: flex;
        flex-direction: row;

        align-items: center;
        justify-content: center;
`;
